export const REASONS_TO_END_SESSION = [
  "User must pass MFA first",
  "Invalid JWT provided",
  "JWT has expired",
  "JWT has been deleted, please re-login",
  "An error has occurred. Please contact support.",
  "No JWT provided",
];
